import React, { useState, useEffect } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/button';

const Header = () => {
  const { language, changeLanguage, t } = useLanguage();
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-lg' : 'bg-white/95 backdrop-blur-sm'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <div className="flex items-center cursor-pointer group" onClick={() => scrollToSection('home')}>
            <img
              src="/images/clients/logosmartin.png"
              alt="SMARTIN Consultoria - Inteligência em Processos, Custos Gerenciais e Pricing"
              className="h-16 sm:h-20 w-auto transition-transform duration-300 group-hover:scale-105"
            />
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('home')}
              className="text-[#193B7F] hover:text-[#45C1E0] transition-colors duration-200 font-medium"
            >
              {t.nav.home}
            </button>
            <button
              onClick={() => scrollToSection('about')}
              className="text-[#193B7F] hover:text-[#45C1E0] transition-colors duration-200 font-medium"
            >
              {t.nav.about}
            </button>
            <button
              onClick={() => scrollToSection('services')}
              className="text-[#193B7F] hover:text-[#45C1E0] transition-colors duration-200 font-medium"
            >
              {t.nav.services}
            </button>
            <button
              onClick={() => scrollToSection('portfolio')}
              className="text-[#193B7F] hover:text-[#45C1E0] transition-colors duration-200 font-medium"
            >
              {t.nav.portfolio}
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="text-[#193B7F] hover:text-[#45C1E0] transition-colors duration-200 font-medium"
            >
              {t.nav.contact}
            </button>

            {/* Language Selector */}
            <div className="flex items-center space-x-2 border-l border-gray-300 pl-6">
              <button
                onClick={() => changeLanguage('pt')}
                className={`transition-opacity duration-200 ${
                  language === 'pt' ? 'opacity-100' : 'opacity-40 hover:opacity-70'
                }`}
                title="Português"
              >
                <span className="text-2xl">🇧🇷</span>
              </button>
              <button
                onClick={() => changeLanguage('en')}
                className={`transition-opacity duration-200 ${
                  language === 'en' ? 'opacity-100' : 'opacity-40 hover:opacity-70'
                }`}
                title="English"
              >
                <span className="text-2xl">🇺🇸</span>
              </button>
            </div>
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden p-2"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? (
              <X className="h-6 w-6" style={{ color: '#193B7F' }} />
            ) : (
              <Menu className="h-6 w-6" style={{ color: '#193B7F' }} />
            )}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden py-4 border-t border-gray-200">
            <nav className="flex flex-col space-y-4">
              <button
                onClick={() => scrollToSection('home')}
                className="text-left text-[#193B7F] hover:text-[#45C1E0] transition-colors duration-200 font-medium"
              >
                {t.nav.home}
              </button>
              <button
                onClick={() => scrollToSection('about')}
                className="text-left text-[#193B7F] hover:text-[#45C1E0] transition-colors duration-200 font-medium"
              >
                {t.nav.about}
              </button>
              <button
                onClick={() => scrollToSection('services')}
                className="text-left text-[#193B7F] hover:text-[#45C1E0] transition-colors duration-200 font-medium"
              >
                {t.nav.services}
              </button>
              <button
                onClick={() => scrollToSection('portfolio')}
                className="text-left text-[#193B7F] hover:text-[#45C1E0] transition-colors duration-200 font-medium"
              >
                {t.nav.portfolio}
              </button>
              <button
                onClick={() => scrollToSection('contact')}
                className="text-left text-[#193B7F] hover:text-[#45C1E0] transition-colors duration-200 font-medium"
              >
                {t.nav.contact}
              </button>
              <div className="flex items-center space-x-4 pt-4 border-t border-gray-200">
                <button
                  onClick={() => changeLanguage('pt')}
                  className={`transition-opacity duration-200 ${
                    language === 'pt' ? 'opacity-100' : 'opacity-40'
                  }`}
                >
                  <span className="text-2xl">🇧🇷</span> Português
                </button>
                <button
                  onClick={() => changeLanguage('en')}
                  className={`transition-opacity duration-200 ${
                    language === 'en' ? 'opacity-100' : 'opacity-40'
                  }`}
                >
                  <span className="text-2xl">🇺🇸</span> English
                </button>
              </div>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
